import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ServiceFilterEntity } from '../../domain/entities/ServiceFilterEntity'

export class ServiceFilterModel extends ServiceFilterEntity {
  regionId?: number
  constructor(dataDto: ServiceFilterEntity) {
    super()
    mapEntityProperties<ServiceFilterModel>(this, dataDto, {
      exclude: ['region'],
      map: {
        regionId: dataDto.region?.id
      }
    })
  }
}
